<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editTermComment="selectedTermComment"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(53)"
        title="Term Comments"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="termComments"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.createdAt | moment("LL") }}</td>
            <td class="text-left">
              <div v-if="item.Term" >{{ item.Term.name }}</div>
            </td>
            <td class="text-left">
              <div v-if="item.Student" >{{ item.Student.fullName }}</div>
            </td>
            <td class="text-left">{{ item.comment }}</td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(55)"
                    @click="editComment(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(56)"
                    @click="deleteComment(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import commentService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "term-comments-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedTermComment: null,
      headers: [
        {
          text: 'Created At',
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Term",
          align: "left",
          value: "Term.name",
          sortable: true,
        },
        {
          text: "Student",
          align: "left",
          value: "Student.fullName",
          sortable: true,
        },
        {
          text: "Comment",
          align: "left",
          value: "comment",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      termComments: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Term Comments List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false 
      this.createDialog = false
      return commentService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.termComments = response.data;
        return response;
      });
    },
    editComment(Termcomment) {
      this.selectedTermComment = Termcomment;
      this.editDialog = !this.editDialog;
    },
    deleteComment(comment) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          commentService.delete(comment.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Comment has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
